import ExaminationDetail from './ExaminationDetail';

export default ExaminationDetail;
